module.exports = __webpack_public_path__ + "img/4.65d70da0.jpg";